module.exports = __webpack_public_path__ + "static/media/loihein.76c5da79.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/loihein.jpg
// module id = 190
// module chunks = 0